import { TransactionPurchaseType } from "@gql/li-api/graphql";
import { useRoutedThirdPartyOrderQuery } from "../hooks/useRoutedThirdPartyOrderQuery";
import { Transaction } from "../../typings/TransactionsResponse";
import { LineLoading } from "./LineLoading";

const TRANSACTION_TYPE_DISPLAY_LOOKUP: Record<TransactionPurchaseType, string> = {
  [TransactionPurchaseType.TitleRegisterDocument]: "Title Register",
  [TransactionPurchaseType.TitlePlanDocument]: "Title Plan",
  [TransactionPurchaseType.OsMapPrint]: "Map Print",
  [TransactionPurchaseType.ThirdPartyOnDemand]: "Third Party On Demand",
  [TransactionPurchaseType.Atkins]: "Atkins",
  [TransactionPurchaseType.LetterSending]: "Letter Sending",
};

const getTransactionTypeDisplay = (type: string) => {
  return TRANSACTION_TYPE_DISPLAY_LOOKUP[type as TransactionPurchaseType] ?? "Other";
};

type TransactionTypeCellProps = {
  transaction: Transaction;
};

export const TransactionTypeCell = ({ transaction }: TransactionTypeCellProps) => {
  const { purchase } = transaction;

  if (purchase?.type === TransactionPurchaseType.ThirdPartyOnDemand) {
    return <ThirdPartyOnDemandTransactionTypeCell transaction={transaction} />;
  }

  return <div data-testid="transaction-type">{getTransactionTypeDisplay(purchase?.type)}</div>;
};

const ThirdPartyOnDemandTransactionTypeCell = ({ transaction }: TransactionTypeCellProps) => {
  const thirdPartyOrderId = transaction.purchase?.reference;
  const { order, loading, error } = useRoutedThirdPartyOrderQuery(thirdPartyOrderId);

  if (loading) {
    return <LineLoading />;
  }

  if (error) {
    return getTransactionTypeDisplay(transaction?.purchase?.type);
  }

  return order?.provider?.displayName;
};
